import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api/client';
import { useAuth } from '../stores/auth';

export default function Login() {
  const [email, setEmail] = useState('');
  const [pass, setPass] = useState('');
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const nav = useNavigate();
  const setSession = useAuth((s) => s.setSession);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setErr(null);
    try {
      const data = await api<{
        access_token: string;
        refresh_token: string;
        inspector: any;
      }>('/inspector/login', {
        method: 'POST',
        body: JSON.stringify({ email, password: pass }),
        auth: false,
      });
      setSession(data.access_token, data.refresh_token, data.inspector);
      nav('/', { replace: true });
    } catch (e: any) {
      setErr(e.message || 'Error de login');
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-8">
          <img src={`${import.meta.env.BASE_URL}icon.png`} alt="" className="w-20 h-20 rounded-2xl mb-3 shadow-md bg-white" />
          <h1 className="text-2xl font-bold text-gray-900">Inspector</h1>
          <p className="text-gray-500 text-sm">Control de estacionamiento</p>
        </div>

        <form onSubmit={onSubmit} className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 space-y-4">
          <div>
            <label className="block text-xs font-semibold text-gray-600 mb-1">Email</label>
            <input
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full bg-gray-50 border border-gray-300 rounded-xl px-3 py-3 text-sm text-gray-900 focus:border-brand-500 outline-none"
            />
          </div>
          <div>
            <label className="block text-xs font-semibold text-gray-600 mb-1">Contraseña</label>
            <input
              type="password"
              autoComplete="current-password"
              value={pass}
              onChange={(e) => setPass(e.target.value)}
              required
              className="w-full bg-gray-50 border border-gray-300 rounded-xl px-3 py-3 text-sm text-gray-900 focus:border-brand-500 outline-none"
            />
          </div>

          {err && (
            <div className="bg-red-50 border border-red-300 text-red-700 text-sm rounded-xl p-3">
              {err}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-brand-500 hover:bg-brand-600 disabled:opacity-50 text-white rounded-xl py-3 font-semibold"
          >
            {loading ? 'Ingresando…' : 'Ingresar'}
          </button>
        </form>

        <p className="text-gray-400 text-xs text-center mt-6">
          Necesitás cuenta de admin con permiso de inspector asignado en el panel municipal.
        </p>
      </div>
    </main>
  );
}
